<template>
    <div
        class="card-option"
        :class="classChoiceCard"
        @click.prevent.stop="$emit('toggle', !isSelected)"
    >
        <slot></slot>

        <Icon
            class="checkmark"
            icon="checkmark"
        />
    </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import Icon from '@/components/ui/icon/Icon.vue'

const props = defineProps<{
    isSelected: boolean | undefined
}>()

defineEmits<{
    (e: 'toggle', v: boolean): void
}>()

const classChoiceCard = computed(() => ({
    selected: props.isSelected,
}))
</script>
<style lang="scss" scoped>
.card-option {
    position: relative;
    width: 25%;
    border: 1px solid $grey-200;
    cursor: pointer;

    .checkmark {
        display: none;
        position: absolute;
        top: 10px;
        right: 10px;
        font-size: 10px;
    }

    &.selected {
        border-color: $green;

        .checkmark {
            display: block;
        }
    }
}
</style>
